import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";

function BalanceTypeModal({
  setFormData,
  modalFilters,
  BalanceType,
  activeBalanceTab,
  updatePendingFilter,
  MethodType,
  activeMethodTab,
  setActiveMethodTab,
  setActiveBalanceTab,
  setModalFilters,
  setActivePage,
}) {
  const { t } = useContext(LanguageContext);

  const applyFilters = () => {
    setFormData((prevData) => {
      let updatedFilters = prevData.search.filters.filter(
        (existingFilter) =>
          !modalFilters.some((pf) => pf.key === existingFilter.key)
      );

      updatedFilters = [
        ...updatedFilters,
        ...modalFilters.filter((filter) => filter.value !== "ALL"),
      ];

      return {
        ...prevData,
        length: 15,
        search: {
          ...prevData.search,
          filters: updatedFilters,
        },
      };
    });
    setActivePage(1);
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    // Hide modal after applying filters
    const modalElement = document.getElementById("offcanvasBalanceFilter");
    if (modalElement) {
      modalElement.classList.remove("show");
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.classList.remove("show");
    }
  };

  const handleClearFilters = () => {
    setFormData((prevData) => {
      return {
        ...prevData,
        search: {
          ...prevData.search,
          filters: prevData.search.filters.filter(
            (filter) =>
              filter.key !== "BALANCE_TYPE" && filter.key !== "PAYMENT_METHOD"
          ),
        },
      };
    });

    setActiveMethodTab(null);
    setActiveBalanceTab(null);
    setModalFilters([]);

    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Hide modal
    const modalElement = document.getElementById("offcanvasBalanceFilter");
    if (modalElement) {
      modalElement.classList.remove("show");
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.classList.remove("show");
    }
  };

  const handleBalanceClick = (value) => {
    setActiveBalanceTab(value);
    updatePendingFilter("BALANCE_TYPE", value);
  };

  const handleMethodClick = (value) => {
    setActiveMethodTab(value);
    updatePendingFilter("PAYMENT_METHOD", value);
  };

  return (
    <div
      className="offcanvas offcanvas-end rounded-4"
      tabIndex="-1"
      id="offcanvasBalanceFilter"
      aria-labelledby="offcanvasBalanceFilterLabel"
      aria-hidden="true"
      style={{ width: "450px" }}
    >
      <div className="offcanvas-header">
        <h4 id="offcanvasBalanceFilterLabel" className="mb-0">
          {t("Filters")}
        </h4>
      </div>
      <div className="offcanvas-body">
        <div className="row">
          <div className="col-12">
            <span className="text-cap small mb-2 text-secondary">
              {t("Balance Type")}{" "}
            </span>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="p-1 nav nav-segment flex-wrap col-12 justify-content-between"
                  style={{
                    backgroundColor: "var(--filter-bg)",
                  }}
                  role="tablist"
                >
                  <li className="col-4">
                    <a
                      id="nav-one-eg1-tab"
                      data-bs-toggle="pill"
                      href="#nav-one-eg1"
                      role="tab"
                      aria-controls="nav-one-eg1"
                      className={`nav-link fs-5 ${
                        !activeBalanceTab ? "active" : ""
                      } `}
                      onClick={() => handleBalanceClick("ALL")}
                      data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                    >
                      {t("All Types")}
                    </a>
                  </li>
                  {BalanceType.map((balance) => (
                    <li className="nav-item col-4" key={balance.value}>
                      <a
                        className={`js-loading-state-invoker nav-link ${
                          activeBalanceTab === balance.value ? "active" : ""
                        } `}
                        id="nav-one-eg1-tab"
                        data-bs-toggle="pill"
                        href="#nav-one-eg1"
                        role="tab"
                        aria-controls="nav-one-eg1"
                        aria-selected={activeBalanceTab === balance.value}
                        onClick={() => {
                          handleBalanceClick(balance.value);
                        }}
                        data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                      >
                        {balance?.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-md-none d-block">
          <div className="col-12">
            <span className="text-cap small mb-2 text-secondary">
              {t("Method Type")}{" "}
            </span>
          </div>
        </div>
        <div className="row mb-3 d-md-none d-block">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap col-12 justify-content-around"
                  style={{
                    backgroundColor: "var(--filter-bg)",
                  }}
                  role="tablist"
                >
                  <li className="col-4">
                    <a
                      id="nav-one-eg1-tab"
                      data-bs-toggle="pill"
                      href="#nav-one-eg1"
                      className={`nav-link fs-5 ${
                        !activeMethodTab ? "active" : ""
                      } `}
                      onClick={() => handleMethodClick("ALL")}
                      data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                    >
                      {t("All")}
                    </a>
                  </li>
                  {MethodType.map((method) => (
                    <li className="nav-item col-4" key={method.value}>
                      <a
                        className={`js-loading-state-invoker nav-link ${
                          activeMethodTab === method.value ? "active" : ""
                        }`}
                        id="nav-one-eg1-tab"
                        data-bs-toggle="pill"
                        href="#nav-one-eg1"
                        role="tab"
                        aria-controls="nav-one-eg1"
                        aria-selected={activeMethodTab === method.value}
                        onClick={() => {
                          handleMethodClick(method.value);
                        }}
                        data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                      >
                        {method.content}{" "}
                        <span className="fs-5 align-middle">{method.name}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="offcanvas-footer">
        <div className="row gx-2">
          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={handleClearFilters}
              >
                {t("Reset filters")}
              </button>
            </div>
          </div>

          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary"
                onClick={applyFilters}
              >
                {t("Apply")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BalanceTypeModal;
